import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { EndpointService } from "@app/endpoint/endpoint.service";
import { ExtractorParams } from "@app/_models";
import { constants } from '@assets/data/constants';
import { SharedUtilService } from '@app/_shared/shared-util.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ValidationTableComponent } from "@app/testcase/validations/validation-table/validation-table.component";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-response-extractor",
  templateUrl: "./response-extractor.component.html",
  styleUrls: ["./response-extractor.component.less"],
})
export class ResponseExtractorComponent implements OnInit {
  readonly TYPE_ENDPOINT = "ENDPOINT";
  readonly TYPE_TESTCASE = "TESTCASE";
  @Input() testcaseDetails: any = {};
  @Input() extractedObject: any = {};
  @Input() respExtParams: any;
  @Input() entityType: string;
  @Input() showGlobalBox = false;
  @Input() permission: any;
  @Input() responseType: string;
  @Input() selectedEndpoint: any;
  hiddenExtractors: any = [];
  @Input() id: any;
  editExtractorIndex: number | null = null;

  @Output() confirmHandler = new EventEmitter<object>();
  syncUpdateToTestCase = false;

  constructor(private route: ActivatedRoute,private modalService: NgbModal, private EndpointServices: EndpointService, private sharedUtilService: SharedUtilService) {}

  ngOnInit() {
    this.testcaseDetails = this.route.snapshot.data.details.response;
    if(this.entityType === "ENDPOINT" ){
    this.EndpointServices.getEndpointById(this.id).subscribe(data => {
      if (data.code === 200) {
        this.hiddenExtractors = data.response.hiddenExtractors
        if(this.hiddenExtractors == null){
          this.hiddenExtractors = [];
        }
      } else {
        return;
      }
    });
    }
    this.extractedObject = {};
    if (!this.respExtParams) {
      this.respExtParams = {};
      if (this.entityType === this.TYPE_TESTCASE) {
        this.respExtParams = [];
      }
    }
  }

  addToExtractedParams() {
    if (this.entityType === this.TYPE_ENDPOINT) {
      if(this.extractedObject.hidden){
        this.hiddenExtractors.push(this.extractedObject.key)
      }
      if (this.extractedObject.key) {
        this.respExtParams[this.extractedObject.key] = this.extractedObject.value;
      }
      this.extractedObject = { key: null, value: null, hidden: false };
      this.confirm();
    } else if (this.entityType === this.TYPE_TESTCASE) {
      
      if (this.editExtractorIndex !== null) {
        this.respExtParams[this.editExtractorIndex] = { ...this.extractedObject };
        this.editExtractorIndex = null;
      }

      if (this.extractedObject.displayValue) {
        let found = false;
        this.respExtParams.forEach((ext, index) => {
          if (ext.displayValue === this.extractedObject.displayValue) {
            this.respExtParams[index] = this.extractedObject;
            found = true;
          }
        });
        if (!found) {
          this.extractedObject.responseSource = this.extractedObject.responseSource || this.responseType;
          this.respExtParams.push(this.extractedObject);
        }
      }
      this.extractedObject = { displayValue: null, pathToExtract: null };
      this.confirm();
    }
  }

  removeFromExtractedParams(key, index?: number) {
    if (this.entityType === this.TYPE_ENDPOINT) {
      this.extractedParamDeletion(this.TYPE_ENDPOINT, key, index);
    } else if (this.entityType === this.TYPE_TESTCASE) {
      this.extractedParamDeletion(this.TYPE_TESTCASE, key, index);
    }
  }

  extractedParamDeletion(entityType: string, key: any, index: number) {
    const relayConfirmMessage = constants.deleteMessage;
    this.sharedUtilService.openConfirmDialog(relayConfirmMessage, false).then((result) => {
      if (result) {
        if (entityType === this.TYPE_ENDPOINT) {
          this.hiddenExtractors = this.hiddenExtractors.filter((item) => item !== key);
          delete this.respExtParams[key];
        } else if (entityType === this.TYPE_TESTCASE) {
          this.respExtParams.splice(index, 1);
        }
        this.confirm();
      }
    });
  }

  confirm(): void {
    const extractorObj: ExtractorParams = {
      isSync: this.syncUpdateToTestCase,
      extractedParams: this.respExtParams,
      hiddenExtractors: this.hiddenExtractors
    };
    this.confirmHandler.emit(extractorObj);
  }

  checkForHidden(key){
    if(this.hiddenExtractors.filter( item => item === key).length > 0){
      return true;
    }
    return false;
  }

  editHidden(key){
    if(this.hiddenExtractors.filter( item => item === key).length > 0){
      this.hiddenExtractors = this.hiddenExtractors.filter((item) => item !== key);
      return;
    }
    this.hiddenExtractors.push(key);

  }
  addtoValidation(data) {
    const modalRef = this.modalService.open(ValidationTableComponent,
          { ariaLabelledBy: 'modal-basic-title',
            windowClass: 'confirm-modal',
            centered: true,
            size: 'xl'
          });
    modalRef.componentInstance.testCaseDetails = this.testcaseDetails;
    modalRef.componentInstance.endpointDetails = data;
    return modalRef.result;
  }

  editParam(index: number): void {
    this.editExtractorIndex = index;
    const param = this.respExtParams[index];
    this.extractedObject = { ...param };
  }

}
